// Automatically imports svgs as react components handled in next.config.js

// imports
import Logo from "./logo.svg";
import Ellipse from "./Ellipse.svg";
import ProductDesign from "./ProductDesign.svg";
import UIDesign from "./UIDesign.svg";
import WebDevelopment from "./WebDevelopment.svg";
import BrandIdentity from "./BrandIdentity.svg";
import AiDriven from "./AiDriven.svg";
import IosAndroidApps from "./IosAndroidApps.svg";
import Thumb from "./Thumb.svg";

// exports
export {
  Logo,
  Ellipse,
  ProductDesign,
  UIDesign,
  WebDevelopment,
  BrandIdentity,
  AiDriven,
  IosAndroidApps,
  Thumb
};
